import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tv-airplane-wrap" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "tv-icon-btn tv-icon-btn--airplane",
      "aria-label": _ctx.ariaLabel,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("svg", {
        class: "tv-paper-plane-svg",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M2.01 21L23 12L2.01 3L2 10l15 2-15 2z"
        })
      ], -1)
    ]), 8, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass(["tv-airplane-badge", { hidden: !_ctx.showBadge }]),
      "aria-hidden": "true"
    }, null, 2)
  ]))
}